import * as React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import {
  Typography,
  Box,
  Stack,
  TextField,
  Button,
  Autocomplete,
  Modal,
} from '@mui/material';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import SaveIcon from '@mui/icons-material/Save';
import BeenhereOutlinedIcon from '@mui/icons-material/BeenhereOutlined';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';

// Stepper
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Check from '@mui/icons-material/Check';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';

// api
import {
  getFluxogramas,
  getGenericData,
} from '../../api';
import { enviaMensagem } from '../../apiWpp';

// import ModalMensagem from './ModalMensagem';
import ModalLoading from '../../ModalLoading';
import ModalAtividadade from '../../ModalAtividade';
import AtividadesPainel from '../../AtividadesPainel';
import ModalAddAgenda from './AddAgenda';
import { cores } from '../../../styles/styleUtils';

// Modal ---------------------------------
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80vw',
  height: '98vh',
  '@media screen and (max-width: 600px)': {
    width: '100vw', // Width de 100% para telas de celulares
    height: '95vh',
  },
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 2,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  backgroundColor: cores.cinzaClaro,
};

const styleTextField = {
  backgroundColor: 'white',
  width: '30vw',
  '@media screen and (max-width: 600px)': {
    width: '70vw', // Width de 100% para telas de celulares
  },
};

const styleTextField2 = {
  backgroundColor: 'white',
  width: '14vw',
  '@media screen and (max-width: 600px)': {
    width: '34vw', // Width de 100% para telas de celulares
  },
};

const styleTextField3 = {
  backgroundColor: 'white',
  width: '15vw',
  '@media screen and (max-width: 600px)': {
    width: '30vw', // Width de 100% para telas de celulares
  },
};

const styleTextField4 = {
  backgroundColor: 'white',
  width: '20vw',
  '@media screen and (max-width: 600px)': {
    width: '30vw', // Width de 100% para telas de celulares
    fontSize: '6px',
  },
};

const sxAddGrupoFatura = {
  width: 100,
};

const sxFontBotaoMobile = {
  '@media screen and (max-width: 600px)': {
    fontSize: 10,
  },
};

// Modal ---------------------------------

const IconButtonWrapper = styled('div')({
  marginLeft: '40px', // Adjust the margin as needed
  display: 'flex',
  alignItems: 'center',
});

// Stepper ------------------------------------

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: cores.laranja,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: cores.laranja,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: cores.laranja,
  }),
  '& .QontoStepIcon-completedIcon': {
    color: cores.laranja,
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? <Check className="QontoStepIcon-completedIcon" /> : <div className="QontoStepIcon-circle" />}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
};

// Stepper ------------------------------------
const finalizadoLead = [
  { nome: 'Lead Qualificado', data: new Date() },
  { nome: 'Lead Desqualificado', data: new Date() },
];
// ----------------

// ----------------------------------------------------------------------
// eslint-disable-next-line
// eslint-disable-next-line
const EditProposta = React.forwardRef((props, ref) => {
  const [dataFetched, setDataFetched] = useState(false);
  const [fluxogramas, setFluxogramas] = useState([]);
  const [steps, setSteps] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);

  const [motivos, setMotivos] = useState([]);
  useEffect(() => {
    const getMotivos = async () => {
      const result = await getGenericData('motivorejeicaolead', {});
      setMotivos(result);
    };
    getMotivos();
  }, []);

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    setModalLoading(true);
    const fluxogramasData = await getFluxogramas();

    setFluxogramas(fluxogramasData);
    setSteps(fluxogramasData.find((value) => value.id === (props.proposta.fluxo.id === 10 ? 10 : 1)).etapas);

    setDataFetched(true);
    setModalLoading(false);
  };


  const [erro, setErro] = useState(false);


  const [proposta, setProposta] = useState(props.proposta);


  useEffect(() => {
    setProposta(props.proposta);
  }, [props.proposta]);


  const [modalMensagem, setModalMensagem] = useState(false);

  const onClose = () => {
    setProposta(null);
    setErro(false);
    props.onClose();
  };

  const [openModalDesqualificado, setOpenModalDesqualificado] = useState(false);
  const [openModalProduto, setOpenModalProduto] = useState(false);
  const [produtoSelecionado, setProdutoSelecionado] = useState(null);

  const PRODUTOS_LEAD = [
    { _id: '69fb36fba8a5817c8defc750', nome: 'Gerador On-Grid' },
    { _id: '69fb36fba8a5817c8defc751', nome: 'Gerador Grid-Zero' },
    { _id: '69fb36fba8a5817c8defc752', nome: 'Gerador Off-Grid' },
    { _id: '69fb36fba8a5817c8defc753', nome: 'Sistema de Bombeamento' },
    { _id: '69fb36fba8a5817c8defc754', nome: 'Serviços' },
  ];
  const [desqualificaData, setDesqualificaData] = useState({
    data: new Date().toISOString().split('T')[0],
    idMotivo: null,
    motivoOpcao: null,
    obs: ''
  });

  const handleLeadQualificado = () => {
    setProdutoSelecionado(PRODUTOS_LEAD[0]);
    setOpenModalProduto(true);
  };

  const handleConfirmarProduto = () => {
    if (!produtoSelecionado) {
      window.alert('Selecione um produto para continuar.');
      return;
    }
    setOpenModalProduto(false);
    setModalLoading(true);
    const newProposta = { ...proposta };
    newProposta.finalizadoLead = { nome: 'Lead Qualificado' };
    newProposta.fluxo = fluxogramas.find((value) => value.id === 1);
    newProposta.etapa = fluxogramas.find((value) => value.id === 1).etapas[0];
    newProposta.finalizado = null;
    newProposta.idMotivoRejeicao = null;
    newProposta.produto = produtoSelecionado;
    const newArray = [...newProposta.atividades];
    newArray.push({
      data: new Date(),
      msg: `Lead Qualificado: ${new Date().toLocaleDateString()} — Produto: ${produtoSelecionado.nome}`,
    });
    newProposta.atividades = newArray;
    props.onConfirm(newProposta);
  };

  const handleLeadDesqualificado = () => {
    if (!desqualificaData.idMotivo || !desqualificaData.data) {
      window.alert('Preencha a data e o motivo de rejeição');
      return;
    }
    setModalLoading(true);
    const newProposta = { ...proposta };
    newProposta.finalizadoLead = { nome: 'Lead Desqualificado' };
    newProposta.finalizado = { ...newProposta.finalizado, nome: 'Rejeitado', data: desqualificaData.data, obs: desqualificaData.obs };
    newProposta.idMotivoRejeicaoLead = desqualificaData.idMotivo;
    newProposta.motivoRejeicaoLead = desqualificaData.motivoOpcao;

    const newArray = [...newProposta.atividades];
    newArray.push({
      data: new Date(),
      msg: `Lead Desqualificado: ${new Date(desqualificaData.data).toLocaleDateString()} - Motivo: ${newProposta.motivoRejeicaoLead?.nome} ${newProposta.finalizado?.obs ? `- Obs: ${newProposta.finalizado.obs}` : ''}`,
    });
    newProposta.atividades = newArray;
    props.onConfirm(newProposta);
    setOpenModalDesqualificado(false);
  };

  // Ao clicar no confirm executa a funcao da props onConfirm retornando produto para o objeto pai
  const handleConfirm = async () => {
    setModalLoading(true);
    if (!areFieldsFilled()) {
      window.alert('Preencha todos os dados para salvar');
      setModalLoading(false);
      return;
    }
    const newProposta = { ...proposta };
    props.onConfirm(newProposta);
  };

  const areFieldsFilled = () => {
    return (
      proposta.cliente !== null
    );
  };

  const handleNext = async () => {
    if (!areFieldsFilled()) {
      window.alert('Preencha todos os dados para avançar');
      return;
    }

    const resultado = fluxogramas.find((value) => value.id === proposta.fluxo.id).etapas[proposta.etapa.id + 1];
    if (resultado?.enviamensagem) {
      const { mensagem, destino } = resultado;
      setModalMensagem(true);
      await enviaMensagem(mensagem, destino, proposta, (enviadoComSucesso, mensagem) => {
        setModalMensagem(false);
        if (!enviadoComSucesso) {
          window.alert('Erro ao enviar mensagem');
        }
      });
    }
    const newArray = [...proposta.backlog];
    // newArray.push({etapa: steps[proposta.etapa.id], data: new Date()})
    setProposta({ ...proposta, etapa: steps[proposta.etapa.id + 1], backlog: newArray });
  };

  const handleBack = () => {
    setProposta({ ...proposta, etapa: steps[proposta.etapa.id - 1] });
  };


  const handleAutoCompleteChange = (idName, name, value) => {
    setProposta({
      ...proposta,
      [idName]: value?._id,
      [name]: value,
    });
  };

  const [modalAddAgenda, setModalAddAgenda] = useState(false);

  const [modalAtividade, setModalAtividade] = useState(false);

  const closeModalAtividade = () => {
    setModalAtividade(false);
  };

  const handleSalvarAtividade = (atividade) => {
    const newArray = [...proposta.atividades];
    newArray.push({
      ...atividade,
      // `msg` mantido por compatibilidade com qualquer lugar do sistema que
      // ainda leia o texto pronto da atividade (ex.: exports/notificações).
      msg: `${atividade.tipo}${atividade.descricao ? `: ${atividade.descricao}` : ''}`,
      ...(proposta.fluxo.id === 4 && { instalacao: true }),
    });
    // Atualize o estado da proposta
    const updatedProposta = {
      ...proposta, // Use o estado atual como base
      atividades: newArray,
    };
    // Atualize o estado uma vez, após todas as operações terem sido concluídas
    setProposta(updatedProposta);
    closeModalAtividade();
  };

  const handleAddAgenda = (agenda) => {
    const newProposta = { ...proposta };
    const newArray = [...newProposta.atividades];
    newArray.push({
      data: new Date(),
      tipo: 'Agenda',
      descricao: agenda.descricaoAgenda,
      usuario: agenda.usuario,
      proximaAcao: true,
      msg: `Adicionado agenda - Usuário: ${agenda.usuario.nome} - Descrição: ${agenda.descricaoAgenda}`,
    });
    // Atualize o estado da proposta
    const updatedProposta = {
      ...newProposta, // Use o estado atual como base
      atividades: newArray,
    };
    props.onConfirm(updatedProposta);
    setModalAddAgenda(false);
  };


  return (
    <>
      {dataFetched &&
        proposta.fluxo.id === 10 && (
          <Box sx={style}>
            <Stack sx={{ width: '100%', backgroundColor: 'white' }} spacing={4}>
              <Stepper alternativeLabel activeStep={proposta.etapa?.id} connector={<QontoConnector />}>
                {steps.map((step) => (
                  <Step key={step.id}>
                    <StepLabel StepIconComponent={QontoStepIcon}>{step.nome}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Stack>
            <Stack direction={'row'} gap={2} sx={{ justifyContent: 'right', mt: 2, mb: -2 }}>
              {proposta._id && (
                <Button
                  size="small"
                  variant="contained"
                  startIcon={<CalendarMonth />}
                  onClick={() => setModalAddAgenda(true)}
                  sx={{ backgroundColor: cores.laranja, '&:hover': { backgroundColor: cores.laranjaEscuro } }}
                >
                  Adicionar Agenda
                </Button>
              )}
            </Stack>
            {
              // Lead Cadastrado --------------
              proposta.etapa?.id === 0 ? (
                <Stack alignItems={'center'} justifyContent={'center'} flexDirection={'row'} flex={1} gap={2}>
                  <Stack alignItems={'center'} sx={{ width: '50%', height: '85%', border: 1, borderRadius: 2 }}>
                    <Stack
                      alignItems={'center'}
                      borderRadius={2}
                      sx={{ backgroundColor: 'white', width: '100%', maxHeight: '80vh' }}
                    >
                      <b>Atividades</b>
                    </Stack>
                      <AtividadesPainel atividades={proposta.atividades} onAdd={() => setModalAtividade(true)} height="55vh" />
                  </Stack>
                </Stack>
              ) : // Tentativa de Contato --------------
                proposta.etapa?.id === 1 ? (
                  <Stack direction={'column'} alignItems={'center'} justifyContent={'center'} flex={1} gap={2}>
                    <Stack alignItems={'center'} sx={{ width: '50%', height: '85%', border: 1, borderRadius: 2 }}>
                      <Stack
                        alignItems={'center'}
                        borderRadius={2}
                        sx={{ backgroundColor: 'white', width: '100%', maxHeight: '80vh' }}
                      >
                        <b>Atividades</b>
                      </Stack>
                        <AtividadesPainel atividades={proposta.atividades} onAdd={() => setModalAtividade(true)} height="55vh" />
                    </Stack>
                  </Stack>
                ) : // Qualificação do Lead --------------
                  proposta.etapa?.id === 2 ? (
                    <Stack flex={1} alignItems={'center'} direction={'row'} gap={5}>
                      <Stack alignItems={'center'} sx={{ width: '50%', height: '85%', border: 1, borderRadius: 2, mb: 5 }}>
                        <Stack
                          alignItems={'center'}
                          borderRadius={2}
                          sx={{ backgroundColor: 'white', width: '100%', maxHeight: '80vh' }}
                        >
                          <b>Atividades</b>
                        </Stack>
                          <AtividadesPainel atividades={proposta.atividades} onAdd={() => setModalAtividade(true)} height="55vh" />
                      </Stack>
                      {
                        !proposta.finalizadoLead?.nome && (
                          <Stack alignItems={'center'} sx={{ width: '50%' }} gap={3}>
                            <Button
                              variant="contained"
                              color="success"
                              startIcon={<ThumbUpIcon />}
                              sx={{ textTransform: 'none', borderRadius: 4, px: 3, py: 1.5, fontSize: 16, width: '60%' }}
                              onClick={handleLeadQualificado}
                              disabled={modalLoading || props.visualiza}
                            >
                              Lead Qualificado
                            </Button>

                            <Button
                              variant="contained"
                              color="error"
                              startIcon={<ThumbDownIcon />}
                              sx={{ textTransform: 'none', borderRadius: 4, px: 3, py: 1.5, fontSize: 16, width: '60%' }}
                              onClick={() => setOpenModalDesqualificado(true)}
                              disabled={modalLoading || props.visualiza}
                            >
                              Lead desqualificado
                            </Button>
                          </Stack>
                        )
                      }
                    </Stack>
                  ) : null
            }

            <Stack direction={'row'} gap={2} justifyContent={'space-between'} sx={{ bottom: 0, left: 0, right: 0, p: 2 }}>
              <Button sx={sxFontBotaoMobile} size={'small'} variant="outlined" onClick={() => onClose()} color="error">
                {' '}
                Cancelar
              </Button>
              <Button
                sx={{ ...sxFontBotaoMobile, backgroundColor: cores.laranja, '&:hover': { backgroundColor: cores.laranjaEscuro } }}
                size={'small'}
                disabled={proposta.etapa.id === 0}
                variant="contained"
                onClick={handleBack}
                startIcon={<ArrowBackIosNewIcon />}
              >
                Anterior
              </Button>
              {proposta.etapa.id + 1 === steps.length ? (
                null
              ) : (
                <Button
                  sx={{ ...sxFontBotaoMobile, backgroundColor: cores.laranja, '&:hover': { backgroundColor: cores.laranjaEscuro } }}
                  size={'small'}
                  variant="contained"
                  disabled={
                    !props.visualiza &&
                    proposta.etapa.nome === 'Revisão' &&
                    erro.tipo === 1 &&
                    !JSON.parse(localStorage.getItem('userData')).supervisor
                  }
                  onClick={handleNext}
                  endIcon={<ArrowForwardIosIcon />}
                >
                  Próximo
                </Button>
              )}
              <Button
                sx={sxFontBotaoMobile}
                size={'small'}
                disabled={modalLoading || props.visualiza || props.proposta.finalizadoLead}
                variant="outlined"
                color="success"
                onClick={handleConfirm}
                startIcon={<SaveIcon />}
              >
                Salvar
              </Button>
            </Stack>
          </Box>
        )}

      {/* Modal Seleção de Produto */}
      <Modal open={openModalProduto} onClose={() => setOpenModalProduto(false)}>
        <Box sx={{ ...style, width: '400px', height: 'auto', minHeight: '25vh', maxHeight: '90vh', backgroundColor: cores.cinzaClaro, borderRadius: 5 }}>
          <Typography variant="h6" fontWeight="bold" mb={3} textAlign="center" color="success.main">
            Lead Qualificado — Selecione o Produto
          </Typography>
          <Autocomplete
            disablePortal
            options={PRODUTOS_LEAD}
            value={produtoSelecionado}
            onChange={(_, value) => setProdutoSelecionado(value)}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            getOptionLabel={(option) => option.nome}
            renderInput={(params) => <TextField {...params} label="Produto" />}
            fullWidth
          />
          <Stack direction="row" justifyContent="flex-end" spacing={2} mt={3}>
            <Button variant="outlined" color="inherit" onClick={() => setOpenModalProduto(false)}>Cancelar</Button>
            <Button variant="contained" color="success" disabled={!produtoSelecionado} onClick={handleConfirmarProduto}>
              Confirmar
            </Button>
          </Stack>
        </Box>
      </Modal>

      {/* Modal Desqualificar Lead */}
      <Modal open={openModalDesqualificado} onClose={() => setOpenModalDesqualificado(false)}>
        <Box sx={{ ...style, width: '600px', height: 'auto', minHeight: '30vh', maxHeight: '90vh', backgroundColor: cores.cinzaClaro, borderRadius: 5 }}>
          <Typography variant="h6" fontWeight="bold" mb={3} textAlign="center" color="error">Desqualificar Lead</Typography>
          <Stack spacing={3}>
            <TextField
              label="Data de Desqualificação"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={desqualificaData.data}
              onChange={(e) => setDesqualificaData({ ...desqualificaData, data: e.target.value })}
            />
            <Autocomplete
              disablePortal
              id="motivoRejeicaoModal"
              value={desqualificaData.motivoOpcao}
              onChange={(_, value) => setDesqualificaData({ ...desqualificaData, idMotivo: value?._id, motivoOpcao: value })}
              options={motivos}
              isOptionEqualToValue={(option, value) => option._id === value?._id}
              getOptionLabel={(option) => `${option.nome}`}
              renderInput={(params) => <TextField {...params} label="Motivo Rejeição" />}
              fullWidth
            />
            <TextField
              label="Descrição / Observação"
              multiline
              rows={4}
              value={desqualificaData.obs}
              onChange={(e) => setDesqualificaData({ ...desqualificaData, obs: e.target.value })}
              fullWidth
            />
            <Stack direction="row" justifyContent="flex-end" spacing={2} mt={2}>
              <Button variant="outlined" color="inherit" onClick={() => setOpenModalDesqualificado(false)}>Cancelar</Button>
              <Button variant="contained" color="error" onClick={handleLeadDesqualificado}>Confirmar</Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      {/* Modal Loading */}
      {modalLoading && <ModalLoading open={modalLoading} />}
      {modalAtividade && (
        <ModalAtividadade open={modalAtividade} onClose={closeModalAtividade} onConfirm={handleSalvarAtividade} />
      )}
      {modalAddAgenda && (
        <ModalAddAgenda
          open={modalAddAgenda}
          onClose={() => setModalAddAgenda(false)}
          proposta={proposta}
          onConfirmAgenda={handleAddAgenda}
        />
      )}
    </>
  );
});

EditProposta.propTypes = {
  produto: PropTypes.object,
  onConfirm: PropTypes.func,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  onClose: PropTypes.func,
};

export default EditProposta;